const DOMCache = {
  body: null,
  footer: null,
  
  getBody() {
    if (!this.body) this.body = document.body;
    return this.body;
  },
  
  getFooter() {
    if (!this.footer) this.footer = document.querySelector('footer');
    return this.footer;
  },
  
  clearCache() {
    this.body = null;
    this.footer = null;
  }
};

// Clear cache when sections reload
document.addEventListener('shopify:section:load', () => {
  DOMCache.clearCache();
});
// ===== END PERFORMANCE OPTIMIZATION =====

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('iframe.media-video-external').forEach((iframe) => {
    const src = iframe.src || '';
    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    } else if (src.includes('vimeo.com')) {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function getTallestElement(selector, context = document) {
  const elements = context.querySelectorAll(selector);
  if (elements.length === 0) return null;
  
  return Array.from(elements).reduce((tallest, current) => {
      return current.offsetHeight > tallest.offsetHeight ? current : tallest;
  });
}

function gotToURL(url, ) {
  if (!url) return;
  window.location.href = url;
}

function adjustLayoutForDevice() {
  const clientWidth = Math.round(document.body.clientWidth);
  if (clientWidth < 750) {
    return 'mobile';
  }
  if (clientWidth > 749 && clientWidth < 1024) {
    return 'tablet';
  }
  return 'desktop'
}

class HandleMedia {
  constructor(media) {
    this.media = media;
  }

  play() {
    if (!this.media) return;
    
    if (this.media.tagName === 'VIDEO') {
      this.media.play();
    } else if (this.media.tagName === 'MODEL-VIEWER') {
      // Use Shopify's modelViewerUI API
      const productModel = this.media.closest('product-model');
      if (productModel && productModel.modelViewerUI) {
        productModel.modelViewerUI.play();
      }
    } else {
      // YouTube/Vimeo iframe handling
      if (this.media.classList.contains('js-vimeo')) {
        this.media.contentWindow.postMessage('{"method":"play"}', '*');
      } else {
        this.media.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
      }
    }
  }

  pause() {
    if (!this.media) return;
    
    if (this.media.tagName === 'VIDEO') {
      this.media.pause();
    } else if (this.media.tagName === 'MODEL-VIEWER') {
      // Use Shopify's modelViewerUI API
      const productModel = this.media.closest('product-model');
      if (productModel && productModel.modelViewerUI) {
        productModel.modelViewerUI.pause();
      }
    } else {
      // YouTube/Vimeo iframe handling
      if (this.media.classList.contains('js-vimeo')) {
        this.media.contentWindow.postMessage('{"method":"pause"}', '*');
      } else {
        this.media.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      }
    }
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class CookieUtility {

  static getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  static setCookie(name, value, expiry) {
    document.cookie = `${name}=${value}; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  static removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}

class ShopifyUtility {
  static formatPrice(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
  
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";
  
      return dollars + cents;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }
}

class QueryParams {
  static getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  static removeQueryParams(params) {
    const url = new URL(window.location.href);
    if (params) {
      for (let index = 0; index < params.length; index++) {
        const param = params[index];
        url.searchParams.delete(param);
      }
    } else {
      url.search = '';
    }
    window.history.pushState({}, '', url);
  }
}

class Dropdown extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector(`[id^="Dropdown-"] summary`) || this.querySelector(`details summary`);
    this.rootSummary = this.querySelector('.dropdown-root-summary');
    this.details = this.querySelector('details');
    this.hover = this.details.getAttribute('data-hover');
    this.dropdownDetails = document.querySelectorAll('insp-dropdown details');
    this.closeIcon = this.querySelectorAll('.dropdown-menu-close');
    this.dropdownLabel = this.details.querySelector('.dropdown-label');
    this.inputValue = this.querySelector('.input-value') || this.querySelector('input[type="hidden"]');
    this.closeIcon.forEach(element => element.addEventListener('click', this.closePopover.bind(this)));

    this.dropdownList = this.querySelector('details .dropdown-menu');
    this.dropdownItems = this.querySelectorAll('.dropdown-menu .selector-item');

    //this.dropdownItems.forEach((item) => item.addEventListener('click', this.itemClickHandler.bind(this, item)));
    this.dropdownItems.forEach((item) => 
      item.addEventListener('click', (e) => this.itemClickHandler(item, e))
    );
    if (this.summary?.nextElementSibling?.getAttribute('id')) {
      this.summary.setAttribute('aria-controls', this.summary.nextElementSibling.id);
    }

    this.summary?.addEventListener('click', (event) => {
      this.togglePopover(event);
    });

    if (this.summary?.closest('header-drawer')) return;
    this.summary?.parentElement?.addEventListener('keyup', onKeyUpEscape);
    if (this.hover == 'true' && screen.width > 1024) {

      this.summary.addEventListener("mouseenter", (event) => {
        setTimeout(() => {
          this.openPopover(event);
        }, 200);
      });

      this.dropdownList.addEventListener("mouseleave", (event) => {
        setTimeout(() => {
          this.closePopover(event);
        }, 200);
      });
    }

    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!target.closest('insp-dropdown')) {
        const dropdowns = document.querySelectorAll('insp-dropdown details');
        dropdowns.forEach(element => {
          element.removeAttribute('open');
        });
      }
    });

  }

  isElementTouchingLeftEdge(el, tolerance = 0) {
    if (!el) return false;
  
    const rect = el.getBoundingClientRect();
  
    // Nếu khoảng cách từ cạnh trái của element tới lề trái của màn hình nhỏ hơn hoặc bằng tolerance
    return Math.abs(rect.left) <= tolerance;
  }

  isElementTouchingRightEdge(el, tolerance = 0) {
    if (!el) return false;
    
    const rect = el.getBoundingClientRect();
    const windowWidth = window.innerWidth;
  
    // Kiểm tra xem cạnh phải của phần tử có "sát" lề phải của window không
    return Math.abs(windowWidth - rect.right) <= tolerance;
  }

  itemClickHandler(item, e) {
    e?.preventDefault();
    e?.stopPropagation();
    const value = item.getAttribute('data-value') || '';
    const label = item.innerHTML;
    for (let index = 0; index < this.dropdownItems.length; index++) {
      const element = this.dropdownItems[index];
      if (element.getAttribute('data-value') == value) {
        element.classList.add('selector-item__active');
      } else {
        element.classList.remove('selector-item__active');
      }
    }
    if (this.inputValue) this.inputValue.value = value;
    if (this.details) this.details.setAttribute('data-value', value);
    if (this.dropdownLabel && label) this.dropdownLabel.innerHTML = label;
    this.dispatchEvent(new CustomEvent('itemChangedData', {
      detail: {
        value: value,
        label: label,
      }
    }));
    this.closePopover();
  }

  closePopover(e) {
    e?.preventDefault();
    e?.stopPropagation();
    this.summary.removeAttribute('aria-expanded');
    this.details.removeAttribute('open');
    this.details.closest('.header-wrapper')?.classList?.remove('mega-menu-opened');

    this.dispatchEvent(new CustomEvent('dropdownToggle', {
      detail: {
        show: false,
      }
    }));

    const childDetails = this.details.querySelector('details');
    if (childDetails) {
      childDetails?.removeAttribute('open');
      childDetails?.querySelector('summary')?.removeAttribute('aria-expanded');
    }

  }

  openPopover(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.dropdownList) return;
    if (this.isElementTouchingRightEdge(this.summary, this.dropdownList.clientWidth - this.summary.clientWidth)) {
      this.dropdownList.style.left = `unset`;
      this.dropdownList.style.right = 0;
    }
    const currentDetails = this.summary.closest('details');

    this.dropdownDetails.forEach(element => {
      const parentDetails = currentDetails?.parentElement.closest('details');
      const parentParentDetails = parentDetails?.parentElement?.closest('details');
      
      if ((element != parentDetails) && element != parentParentDetails) {
        element.removeAttribute('open');
      }
    });
    
    this.summary.setAttribute('aria-expanded', '');
    this.details.setAttribute('open', '');
    const header = document.querySelector('.header');
    if (e.target.closest('.list-menu__item') && e.target.closest('.list-menu__item').classList.contains('mega-menu')) {
      this.details.closest('.header-wrapper')?.classList?.add('mega-menu-opened');
    }

    const dropdownHeight = this.dropdownList?.clientHeight || 0;
    const windowHeight = window.innerHeight
    const dropdownTop = this.summary.getBoundingClientRect().top

    if (!this.dropdownList) return;
    if (this.summary.closest('.mega-menu')) {
      document.documentElement.style.setProperty('--menu-item-to-top', `${Math.round(header.clientHeight + header.getBoundingClientRect().top)}px`);
    } else {
      if (dropdownTop + dropdownHeight + 100 > windowHeight) {
        this.dropdownList.classList.add('dropdown-top');
        this.dropdownList.classList.remove('dropdown-bottom');
      } else {
        this.dropdownList.classList.add('dropdown-bottom');
        this.dropdownList.classList.remove('dropdown-top');
      }
    }

    this.dispatchEvent(new CustomEvent('dropdownToggle', {
      detail: {
        show: true,
      }
    }));

  }

  togglePopover(e) {
    e.preventDefault();
    e.stopPropagation();
    const isOpen = this.details.hasAttribute('open');
    if (isOpen) {
      this.closePopover(e);
    } else {
      this.openPopover(e);
    }
  }
}

if (!customElements.get('insp-dropdown')) { customElements.define('insp-dropdown', Dropdown); }

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const btn = event.target.closest('button');
    if (!btn) return;
    btn.getAttribute('name') === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class CollapseElement extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector('summary');
    this.summary?.addEventListener('click', this.toggle.bind(this));

    document.addEventListener('shopify:section:load', function (event) {
      const collapses = event.target.querySelectorAll('collapse-element');
      collapses.forEach(collapse => {
        const summary = collapse.querySelector('summary');
        summary?.addEventListener('click', this.toggle.bind(this));
      });
    });
  }

  toggle() {
    this.toggleAttribute('open');
  }
}

if (!customElements.get('collapse-element')) { customElements.define('collapse-element', CollapseElement); }

class TabsElement extends HTMLElement {
  constructor() {
    super();
    this.tabsTitle = this.querySelectorAll('.tabs-actions .tab-title');
    this.tabsContent = this.querySelectorAll('.tabs-content .tab-content');

    this.tabsTitle.forEach((title) => title.addEventListener('click', this.onClickTab.bind(this)));
    for (let index = 0; index < this.tabsTitle.length; index++) {
      const element = this.tabsTitle[index];
      element.style.setProperty('--tab-title-width', `${element.clientWidth}px`);
    }
  }

  onClickTab(e) {
    const target = e.target.closest('.tab-title');
    if (target) {
      const dataId = target.getAttribute('data-id');
      for (let index = 0; index < this.tabsTitle.length; index++) {
        const element = this.tabsTitle[index];
        const elementId = element.getAttribute('data-id');
        if (dataId.trim() == elementId.trim()) {
          element.classList.add('tab-active');
        } else {
          element.classList.remove('tab-active');
        }
      }
      for (let index = 0; index < this.tabsContent.length; index++) {
        const element = this.tabsContent[index];
        const elementId = element.getAttribute('data-id');
        if (dataId.trim() == elementId.trim()) {
          element.classList.add('tab-active');
        } else {
          element.classList.remove('tab-active');
        }
      }
    }

    this.dispatchEvent(new CustomEvent('tabChanged', {
      detail: {
        tabId: target?.getAttribute('data-id') || null,
        target: target || null,
      }
    }));
  }

  toggle() {
  }
}

if (!customElements.get('tabs-element')) { customElements.define('tabs-element', TabsElement); }

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.headerModalElemets = {
      modal: this.querySelector('#menu-drawer'),
      menuItems: this.querySelector('.menu-drawer__items'),
      modalHeader: this.querySelector('#menu-drawer .base-modal__header'),
      modalContent: this.querySelector('#menu-drawer .base-modal__content'),
      modalFooter: this.querySelector('#menu-drawer .base-modal__footer'),
      modalBack: this.querySelector('#menu-drawer .menu-drawer__back'),
      modalInner: this.querySelector('#menu-drawer .base-modal__inner'),
      backIcon: this.querySelector('#menu-drawer .icon-back'),
      details: this.querySelectorAll('details'),
      searchInput: document.querySelector('#menu-drawer input[type="search"]'),
      languageSelectorButton: this.querySelector('.language-region-selector-button'),
      countrySelectorButton: this.querySelector('.country-region-selector-button'),
      languageCountrySelectorContainer: this.querySelector('.language-country-selector__container'),
    };

    this.bindEvents();
  }

  bindEvents() {
    const {backIcon, searchInput, modal, languageSelectorButton, countrySelectorButton} = this.headerModalElemets;
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    backIcon?.addEventListener('click', this.resetElements.bind(this));
    searchInput?.addEventListener('click', this.onClickSearchInput.bind(this));
    modal?.addEventListener('modalChanged', this.onHeaderModalChange.bind(this));
    countrySelectorButton?.addEventListener('click', this.onShowLanguageCountrySelector.bind(this));
    languageSelectorButton?.addEventListener('click', this.onShowLanguageCountrySelector.bind(this))
  }

  onShowLanguageCountrySelector(e) {
    const target = e.target.closest('.list-menu__item');
    const title = target.dataset.title || target.getAttribute('data-title') || '';
    const type = target.dataset.type || target.getAttribute('data-type') || '';
    
    const {languageCountrySelectorContainer, menuItems, modalInner, modalBack} = this.headerModalElemets;
    languageCountrySelectorContainer?.classList?.remove('hidden');
    menuItems?.classList?.add('hidden');
    modalInner.classList.add(`openning-${type}-selector`);
    
    if (modalBack) {
      const menuBackContent = modalBack.querySelector('.menu-drawer__back-content');
      if (menuBackContent) menuBackContent.textContent = title;
    }
  }

  onHeaderModalChange(e) {
    this.resetElements(e);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    
    if (isOpen) {
      summaryElement.setAttribute('aria-expanded', false);
    } else {
      this.openMenuDrawer(summaryElement);
    };
  }

  onClickSearchInput(e) {
    e.preventDefault();
    e.stopPropagation();
    this.headerModalElemets?.modal?.hide();
    const searchModal = document.getElementById('modal-search');
    searchModal?.show();
  }

  onClickSearchIcon(e) {
    e.preventDefault();
    e.stopPropagation();
    const searchBtn = e.target.closest('.search__button');
    if (searchBtn) {
      const dataModal = searchBtn.getAttribute('data-modal');
      const modal = document.getElementById(dataModal) || document.querySelector(dataModal);

      if (modal) modal.show(searchBtn);
      this.closeMenuDrawer(e);
    }
  }

  openMenuDrawer(summaryElement) {
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    if (!summaryElement.classList.contains('dropdown-summary')) {
      this.mainDetailsToggle.classList.add('menu-opening');
      if (this.headerModalElemets.modalInner) this.headerModalElemets.modalInner.classList.add('openning-sub-menu');
      if (this.headerModalElemets.modalBack) {
        const menuBackContent = this.headerModalElemets.modalBack.querySelector('.menu-drawer__back-content');
        const title = summaryElement.dataset.title || summaryElement.getAttribute('data-title') || '';
        if (menuBackContent) menuBackContent.textContent = title;
      }
    }
  }

  resetElements(e) {
    e.preventDefault();
    e.stopPropagation();
    removeTrapFocus();
    const {modalInner, details, languageCountrySelectorContainer, menuItems} = this.headerModalElemets;
    if (modalInner) {
      modalInner.classList.remove('openning-sub-menu');
      modalInner.classList.remove('openning-country-selector');
      modalInner.classList.remove('openning-language-selector');
    }
    languageCountrySelectorContainer?.classList?.add('hidden');
    menuItems?.classList?.remove('hidden');
    if (this.mainDetailsToggle) this.mainDetailsToggle.classList.remove('menu-opening');
    (details || []).forEach(detail => {
      detail.removeAttribute('open');
      detail.classList.remove('menu-opening');
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.backDrop = this.querySelector('.modal-backdrop');
    this.closeButton = this.querySelector('.base-modal__close') || this.querySelector('[id^="ModalClose-"]');
    this.modalContent = this.querySelector('.base-modal__content');
    if (!this.backDrop && this.querySelector('.base-modal')) {
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop';
      this.appendChild(backdrop);
      this.backDrop = this.querySelector('.modal-backdrop');
    }
    this.closeButton?.addEventListener(
      'click',
      this.hide.bind(this)
    );
    
    if (this.modalContent) {
      this.modalContent.addEventListener('scroll', this.handleScroll.bind(this));
      this.modalContent.removeEventListener('scroll', this.handleScroll.bind(this));
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.backDrop) this.backDrop.addEventListener('click', this.hide.bind(this))
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    this.backDrop = this.querySelector('.modal-backdrop');
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.classList.add('overflow-hidden');
    document.documentElement.style.paddingRight = scrollBarWidth + "px";
    if (this.backDrop) this.backDrop.classList.add('active');
    this.setAttribute('open', '');
    this.dispatchEvent(new CustomEvent('modalChanged', {
      detail: {
        show: true,
      }
    }));
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

  }

  hide() {
    document.documentElement.classList.remove("overflow-hidden");
    document.documentElement.style.paddingRight = "";
    this.backDrop = this.querySelector(".modal-backdrop");
    if (this.backDrop) this.backDrop.classList.remove("active");
    this.removeAttribute("open");
    
    const openerToFocus = this.openedBy;
    removeTrapFocus();
    
    if (openerToFocus && document.body.contains(openerToFocus)) {
      const quickAddButton = openerToFocus.closest('quick-add-button');
      
      setTimeout(() => {
        try {
          openerToFocus.focus();
          
          if (quickAddButton) {
            // Remove class when focus leaves the button
            const handleFocusOut = () => {
              quickAddButton.classList.remove('modal-is-open');
              openerToFocus.removeEventListener('blur', handleFocusOut);
              openerToFocus.removeEventListener('focusout', handleFocusOut);
            };
            
            // Listen for focus leaving the button
            openerToFocus.addEventListener('blur', handleFocusOut, { once: true });
            openerToFocus.addEventListener('focusout', handleFocusOut, { once: true });
            
            // Also remove after 500ms in case focus events don't fire
            setTimeout(() => {
              if (quickAddButton.classList.contains('modal-is-open')) {
                quickAddButton.classList.remove('modal-is-open');
                openerToFocus.removeEventListener('blur', handleFocusOut);
                openerToFocus.removeEventListener('focusout', handleFocusOut);
              }
            }, 500);
          }
        } catch(e) {
          console.warn('Could not return focus:', e);
          if (quickAddButton) {
            quickAddButton.classList.remove('modal-is-open');
          }
        }
      }, 50);
    }
    
    window.pauseAllMedia();
    this.dispatchEvent(new CustomEvent("modalChanged", {detail: {show: false}}));
  }

  handleScroll(event) {
    if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 100) {
      if (this.modalContent) this.modalContent.classList.add('mark-image-none');
    } else {
      if (this.modalContent) this.modalContent.classList.remove('mark-image-none');
    }
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('modal-dialog', ModalDialog);

class CookieBannerModal extends ModalDialog {
  constructor() {
    super();
    this.declineButton = this.querySelector('.button-decline');
    this.acceptButton = this.querySelector('.button-accept');
    this.cookieName = 'cookies-banner'
    this.declineButton?.addEventListener('click', this.onDecline.bind(this));
    this.acceptButton?.addEventListener('click', this.onAccept.bind(this));
    this.initialize();
  }

  initialize() {
    const hasCookie = this.getCookie(this.cookieName);
    if (!hasCookie) {
      setTimeout(() => {
        this.show();
      }, 3000);
    }
  }

  onDecline() {
    this.hide();
  }

  onAccept() {
    this.setCookie(this.cookieName, 365);
    this.hide();
  }
};
customElements.define('cookie-banner-dialog', CookieBannerModal);

class AgeVerificationDialog extends ModalDialog {
  constructor() {
    super();
    this.cookieName = 'age-verification';
    this.declineButton = this.querySelector('.button-decline');
    this.acceptButton = this.querySelector('.button-accept');
    this.returnButton = this.querySelector('.button-return');
    this.declineContent = this.querySelector('.age-verification__decline-content');
    this.ageVerificationContent = this.querySelector('.age-verification__container');
    this.declineButton?.addEventListener('click', this.onDecline.bind(this));
    this.acceptButton?.addEventListener('click', this.onAccept.bind(this));
    this.returnButton?.addEventListener('click', this.onReturn.bind(this));
    this.initialize();
  }

  initialize() {
    const hasCookie = this.getCookie(this.cookieName);
    if (!hasCookie) {
      this.show();
    }
  }

  onDecline() {
    this.declineContent.classList.remove('hidden');
    this.ageVerificationContent.classList.add('hidden');
  }

  onAccept() {
    const acceptCookie = this.getCookie('cookies-banner');
    if (acceptCookie) {
      this.setCookie(this.cookieName, 365);
    }
    this.hide();
  }

  onReturn() {
    this.declineContent.classList.add('hidden');
    this.ageVerificationContent.classList.remove('hidden');
  }
}

customElements.define('age-verification-dialog', AgeVerificationDialog);

class PromotionDialog extends ModalDialog {
  constructor() {
    super();
    this.cookieName = 'promotion';
    this.appearance = this.getAttribute('data-appearance');
    this.frequency = this.getAttribute('data-frequency');
    this.initialize();
  }

  initialize() {
    const hasCookie = this.getCookie(this.cookieName);
    if (!hasCookie) {
      setTimeout(() => {
        this.show();
      }, Number(this.appearance || 1) * 1000);
    }
  }

  hide() {
    super.hide();
    const acceptCookie = this.getCookie('cookies-banner');
    if (acceptCookie) {
      this.setCookie(this.cookieName, Number(this.frequency));
    }
  }
};

customElements.define('promotion-dialog', PromotionDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.buttonOpener = this.querySelector('.button') || this.querySelector('.opener');
    this.modal = document.getElementById(this.getAttribute('data-modal')) || document.querySelector(this.getAttribute('data-modal'));
    
    if (!this.buttonOpener) return;
    this.buttonOpener.addEventListener('click', this.openDrawer.bind(this));
  }

  openDrawer(e) {
    e.stopPropagation();
    e.preventDefault();
    
    if (this.modal) this.modal.show(this.buttonOpener);
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.media = this.querySelector('video, iframe, model-viewer');
    
    this.deferredMedia = this.querySelector('.deferred-media__poster');
    this.playButton = this.querySelector('.deferred-media__poster .icon-play-video');
    this.pauseButton = this.querySelector('.deferred-media__poster .icon-pause-video');
    this.addEventListener('click', this.onClickMedia.bind(this));

    if (this.playButton) {
      this.playButton.addEventListener('click', this.play.bind(this));
    }
    
    if (this.pauseButton) {
      this.pauseButton.addEventListener('click', this.pause.bind(this));
    }
    
  }

  onClickMedia(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const isPlaying = this.getAttribute('data-play') == 'true';
    
    if (isPlaying) {
      this.pause(e);
    }
  }

  play(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setAttribute('data-play', 'true');
    const handleMedia = new HandleMedia(this.media);
    handleMedia.play();
  }

  pause(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setAttribute('data-play', 'false');
    
    const handleMedia = new HandleMedia(this.media);
    handleMedia.pause();
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      this.setAttribute('loaded', true);
      const deferredElement = this.querySelector('video, model-viewer, iframe');
      if (focus) deferredElement.focus();
    }
  }
  
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('.slider__slide');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]:not(.slider-arrow)');
    this.nextButton = this.querySelector('button[name="next"]:not(.slider-arrow)');
    this.prevButtonArrow = this.querySelector('button.slider-arrow[name="previous"]');
    this.nextButtonArrow = this.querySelector('button.slider-arrow[name="next"]');
    this.totalPages = 0;
    
    if (!this.slider) {
      return;
    }

    this.sliderWidth = this.slider?.offsetWidth || 0;
    this.sliderHeight = this.slider?.offsetHeight || 0;
    this.slideScrollPosition = 0;
    this.currentPage = parseInt(this.slider?.getAttribute('data-page') || '1', 10);
    this._scrollEndTimer = null;
    this._lastComputedPage = this.currentPage;
    this.totalWidth = 0;
    this.pagination = this.querySelector('.slider-pagination');
    this.paginationMobile = this.querySelector('.slider-pagination-mobile');
    this.paginationButtons = document.querySelectorAll('.slider-pagination-button');
    this.startX = 0;
    this.endX = 0;
    this.layout = 'horizontal';
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.spacing = this.slider.getAttribute('data-spacing') || '32';

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    document.addEventListener('shopify:section:load', function (event) {
      const blockSelectedIsSlides = event.target.querySelectorAll('slider-component, .slider-gutter');
      if (blockSelectedIsSlides.length == 0) return;
      blockSelectedIsSlides.forEach(parentSlideshowComponent => {
        if (parentSlideshowComponent) {
          parentSlideshowComponent.initPages();
        }
        if (parentSlideshowComponent.parentElement.getAttribute('data-autoplay') === 'true') {
          parentSlideshowComponent.setAutoPlay();
        }
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      const blockSelectedIsSlide = event.target.classList.contains('slider__slide');
      if (!blockSelectedIsSlide) return;
      const parentSlideshowComponent = event.target.closest('slider-component');
      if (!parentSlideshowComponent) return;
      parentSlideshowComponent.goToSlideByOffset(event.target);
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      this.initPages();
    }, 150), { passive: true });

    if (!this.slider) return;

    this.initPages();
    // OPTIMIZATION: Added passive listener
    this.slider.addEventListener('scroll', this.scroll.bind(this), { passive: true });

    if (this.nextButton && this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.nextButtonArrow && this.prevButtonArrow) {
      this.prevButtonArrow.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButtonArrow.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.paginationButtons) {
      this.paginationButtons.forEach((item, index) => {
        item.addEventListener('click', this.goToSlideByIndex.bind(this));
      })
    }
  }

  getTotalPages() {
    const container = this.slider;
    const items = this.sliderItems;
    const direction = this.layout;

    if (!container || !items || items.length === 0) return 1;

    const containerRect = container.getBoundingClientRect();
    const firstItemRect = items[0].getBoundingClientRect();

    let visibleItems = 0;

    if (direction === "horizontal") {
      visibleItems = Math.floor(containerRect.width / firstItemRect.width);
    } else {
      visibleItems = Math.floor(containerRect.height / firstItemRect.height);
    }

    return Math.max(1, items.length - visibleItems + 1);
  }

  initPages() {
    const isDevice = adjustLayoutForDevice();

    if (isDevice != 'mobile') {
      this.slider.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault();
        }
      }, { passive: false });
    }

    // OPTIMIZATION: Added passive listeners to touch events
    this.slider.querySelectorAll('.slider__slide').forEach(element => {
      element.addEventListener('touchstart', this.onSlideTouchStart.bind(this), { passive: true });
      element.addEventListener('touchend', this.onSlideTouchEnd.bind(this), { passive: true });
    });

    if (isDevice == 'mobile') {
      this.layout = this.slider.getAttribute('data-layout-mobile') || 'horizontal';
    } else {
      this.layout = this.slider.getAttribute('data-layout-desktop') || 'horizontal';
    }
    
    setTimeout(() => {
      this.totalPages = this.getTotalPages();
      const sliderPaginationTotalPages = this.pagination?.querySelector('.slider-pagination__total-pages');
      const sliderPaginationCurrentPage = this.pagination?.querySelector('.slider-pagination__current-page');
      if (sliderPaginationTotalPages) {
        if (this.totalPages > 9) {
          sliderPaginationTotalPages.textContent = `${this.totalPages}`;
        } else {
          sliderPaginationTotalPages.textContent = `0${this.totalPages}`;
        }
      }

      if (sliderPaginationCurrentPage) {
        sliderPaginationCurrentPage.textContent = `01`;
      }
      if (isDevice != 'mobile') {
        if (this.totalPages < 2) {
          this.slider.classList.remove('slider--everywhere');
  
          if (this.prevButtonArrow) {
            this.prevButtonArrow.style.display = 'none';
          }
          if (this.nextButtonArrow) {
            this.nextButtonArrow.style.display = 'none';
          }
        }
      }

    }, 500);
  }

  onSlideTouchStart(e) {
    const isDevice = adjustLayoutForDevice();
    if (isDevice == 'desktop') {
      e.preventDefault();
      e.stopPropagation();
    }
    
    this.dispatchEvent(new CustomEvent('slideTouchstart', {
      detail: {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }
    }))
  }

  onSlideTouchEnd(e) {
    const isDevice = adjustLayoutForDevice();
    if (isDevice == 'desktop') {
      e.preventDefault();
      e.stopPropagation();
    }

    this.dispatchEvent(new CustomEvent('slideTouchend', {
      detail: {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }
    }))
  }

  goToSlideByOffset(item) {
    const scrollLeft = item.offsetLeft;
    const page = Math.floor(scrollLeft / (item.clientWidth)) == 0 ? 1 : Math.floor(scrollLeft / (item.clientWidth)) + 1;
    
    if (page <= this.totalPages) {
      this.currentPage = page;
    } else {
      this.currentPage = this.totalPages;
    }
    this.goToSlide();
  }

  scroll(event) {
    // OPTIMIZATION: Removed event.preventDefault() and event.stopPropagation()
    const container = event.target;
    
    // OPTIMIZATION: Cache computed styles
    if (!this._cachedColumnGap) {
      const style = getComputedStyle(container);
      this._cachedColumnGap = parseInt(style.columnGap, 10) || 0;
    }
    
    const columnGap = this._cachedColumnGap;
    const referenceItem = this.sliderItems[this.currentPage - 1] || this.sliderItems[0];
    const itemWidth = (referenceItem?.clientWidth || 0) + columnGap || 1;
    const scrollLeft = container.scrollLeft;
    let computedPage = Math.round(scrollLeft / itemWidth) + 1;
    computedPage = Math.min(Math.max(1, computedPage), this.totalPages || 1);

    this._lastComputedPage = computedPage;

    clearTimeout(this._scrollEndTimer);
    this._scrollEndTimer = setTimeout(() => {
      this._onScrollEnd();
    }, 10);
  }

  _onScrollEnd() {
    const currentPage = this._lastComputedPage || 1;
    this.currentPage = currentPage;

    const sliderPaginationCurrentPage = this.pagination?.querySelector('.slider-pagination__current-page');
    if (sliderPaginationCurrentPage) {
      sliderPaginationCurrentPage.textContent = currentPage < 10 ? `0${currentPage}` : `${currentPage}`;
    }

    if (this.prevButtonArrow) this.prevButtonArrow.disabled = (currentPage === 1);
    if (this.nextButtonArrow) this.nextButtonArrow.disabled = (currentPage === this.totalPages);

    this.dispatchEvent(new CustomEvent('slideChanged', {
      detail: {
        currentPage,
        totalPages: this.totalPages,
        currentElement: this.sliderItemsToShow[currentPage - 1]
      }
    }));
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  goToSlide() {
    const container = this.slider;
    const items = this.sliderItems;
    const page = Number(this.currentPage) || 1;
    const targetIndex = Math.max(0, page - 1);
    const target = items[targetIndex];
    if (!target) return;

    void container.offsetHeight;
    if (this.layout === 'vertical') {
      const scrollTop = target.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
      requestAnimationFrame(() => container.scrollTo({ left: scrollTop, behavior: "smooth" }));
    } else {
      const scrollLeft = target.offsetLeft - container.clientLeft;
      requestAnimationFrame(() => container.scrollTo({ left: scrollLeft, behavior: "smooth" }));
    }

    const sliderPaginationCurrentPage = this.pagination?.querySelector('.slider-pagination__current-page');
    if (sliderPaginationCurrentPage) sliderPaginationCurrentPage.textContent = page < 10 ? `0${page}` : `${page}`;
  }

  goToSlideByIndex(event) {
    let index = event.target.getAttribute('data-index');
    if (index) {
      if (this.sliderItems.length >= index) {
        const item = this.sliderItems[index - 1];
        let position = item.offsetLeft;
        this.slider.scrollTo({
          left: position,
        });
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.target.closest('.slider-arrow') || event.target.closest('.slider-button');
    const name = target.getAttribute('name');
    this.currentPage = this.currentPage?this.currentPage:1;
    if (name == 'next') {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
      }
    } else if (name == 'previous') {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    }
    this.goToSlide();
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    this.play();
  }

  focusInHandling(event) {
    this.pause();
  }

  setAutoPlay() {
    console.log(this.slider.dataset.speed);
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  autoRotateSlides() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
    } else {
      this.currentPage = 1
    }
    this.goToSlide();

  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }
}

customElements.define('slider-component', SliderComponent);

class logolistSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.quoteSubheading = this.querySelector('.logo-list__container').querySelector('.logo-list-quote-subheading');
    this.quoteHeading = this.querySelector('.logo-list__container').querySelector('.logo-list-quote-heading');
    this.quotes = this.querySelectorAll('.logo-list-text-quote__container .logo-list-text-quote');
    this.medias = this.querySelectorAll('.list-logo__item .media');
    this.enable = this.getAttribute('data-enable');
    if (this.enable && this.enable == 'false') return;
    if (this.medias.length > 0) this.medias[0].classList.add('active-logo');
    this.querySelector('infinity-scroll-element').addEventListener('onClickScrollItem', debounce(this.onClickItem.bind(this), 0)) 
  }

  isInViewport(el, container) {
    const elRect = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
  
    return (
      elRect.left < containerRect.right && 
      elRect.right > containerRect.left
    );
  }

  onClickItem(e) {
    const item = e?.detail?.item;
    if (!item) return;
    
    const quoteId = item.getAttribute('data-quote');
    const currentId = `list-logo__item-image-${quoteId}`;
    this.medias = this.querySelectorAll('.list-logo__item .media');

    for (let index = 0; index < this.medias.length; index++) {
      const element = this.medias[index];
      if (element.classList.contains(currentId)) {
        element.classList.add('active-logo');
      } else {
        element.classList.remove('active-logo');
      }
    }

    for (let index = 0; index < this.quotes.length; index++) {
      const element = this.quotes[index];
      const currentQuoteId = element.getAttribute('data-quote');
      
      if (quoteId == currentQuoteId) {
        element.classList.add('active-quote');
      } else {
        element.classList.remove('active-quote');
      }
    }

    const infinityElement = this.querySelector('infinity-scroll-element');
    if (infinityElement) {
      infinityElement.container.scrollLeft += infinityElement.firstChildWidth;
    }
  }

};
customElements.define('logo-list-component', logolistSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.items = this.querySelectorAll('.slideshow__slide');
    this.originalItems = [...this.items];
    this.slideArrows = this.querySelectorAll('.slider-arrow');
    this.slideCounterCurrent = this.querySelector(".slider-counter--current");
    this.slideCounterTotal = this.querySelector(".slider-counter--total");
    this.slideControls = this.querySelectorAll('.slider-counter__link');
    this.slideControlButtons = this.querySelectorAll('.slideshow-navigator-button');
    this.firstItem = this.items?.[0];
    this.lastItem = this.items?.[this.items.length - 1];
    this.animation = 500;
    this.isMultiple = this.slider.dataset.layout == 'multiple' && this.slider.getBoundingClientRect().width > 600;
    this.currentPage = this.isMultiple ? 1 : 0;
    this.multipleItemWidth = this.slider.getAttribute('multiple-item-width') || 0.5;

    document.addEventListener('shopify:block:select', this.handleSlideshowEvent.bind(this));
    document.addEventListener('shopify:section:load', this.handleSlideshowLoad.bind(this));

    this.slider.addEventListener("transitionend", () => {
      this.currentPage = Number(this.slider.dataset.page || 0);
      if (this.currentPage <= -1) this.currentPage = this.originalItems.length - 1;
      if (this.currentPage >= this.originalItems.length) this.currentPage = 0;
      this.anim(0);
    });

    this.slideArrows.forEach(btn => btn.addEventListener('click', this.onClickArrow.bind(this)));
    this.slideControlButtons.forEach(btn => btn.addEventListener('click', this.onClickArrow.bind(this)));
    this.slideControls.forEach(btn => btn.addEventListener('click', this.onClickControl.bind(this)));

    this.initSliderShow();
  }

  handleSlideshowEvent(event) {
    const slideElement = event.target;
    if (!slideElement.classList.contains('slideshow__slide')) return;
    const slideshowComponent = slideElement.closest('slideshow-component');
    const dataIndex = parseInt(slideElement.getAttribute('data-index')) || 1;
    this.updateSlideshow(slideshowComponent, dataIndex);
  }

  handleSlideshowLoad(event) {
    const slideshowContainer = event.target.querySelector('.slideshow-container');
    if (!slideshowContainer) return;
    const slideshowComponent = event.target.querySelector('slideshow-component');
    const defaultIndex = 2;
    this.updateSlideshow(slideshowComponent, defaultIndex);
  }

  updateSlideshow(slideshowComponent, dataIndex) {
    const slider = slideshowComponent.slider;
    const layout = slider.dataset.layout;
    const isMultipleLayout = layout === 'multiple' && slider.getBoundingClientRect().width > 600;
    let x = dataIndex - 1;

    if (isMultipleLayout) {
      x = dataIndex * slideshowComponent.multipleItemWidth - (1 - slideshowComponent.multipleItemWidth) / 2;
    }

    slider.style.transitionDuration = '500ms';
    slider.style.transform = `translateX(${-x * 100}%)`;
    slider.dataset.page = Math.max(dataIndex - 1, 0);

    slideshowComponent.originalItems.forEach((slide) => {
      slide.classList.toggle('active-slide', dataIndex == slide.dataset.index);
    });
  }

  initSliderShow() {
    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    if (this.isMultiple) {
      this.slider.prepend(this.originalItems[this.originalItems.length - 1].cloneNode(true));
      this.slider.append(this.originalItems[0].cloneNode(true));
      this.items = this.slider.querySelectorAll('.slideshow__slide');
    }
    if (this.slideCounterTotal) this.slideCounterTotal.innerHTML = this.totalPages.toString().padStart(2, "0");
    this.anim(0);
  }

  setCounterCurrentSlide() {
    if (this.slideCounterCurrent) this.slideCounterCurrent.innerHTML = (this.currentPage + 1).toString().padStart(2, "0");
  }

  mod(n, m) {
    return (n % m + m) % m;
  }

  anim(ms = this.animation) {
    const page = this.currentPage || 0;
    let x = page;

    if (this.isMultiple) {
      x = (page * 1) * this.multipleItemWidth - (1 - this.multipleItemWidth) / 2;
    }

    this.slider.style.transitionDuration = `${ms}ms`;
    this.slider.style.transform = `translateX(${(-x) * 100}%)`;

    this.originalItems.forEach((elSlide) => {
      elSlide.classList.toggle("active-slide", page + 1 == elSlide.dataset.index);
    });

    (this.slideControls || []).forEach((elSlide) => elSlide.classList.toggle("slider-counter__link--active", page + 1 == elSlide.dataset.page));
    (this.slideControls || []).forEach((elSlide) => {
      elSlide.classList.toggle('active-bar-last-child', page + 1 == elSlide.dataset.page);
      elSlide.classList.toggle('active-bar', (page + 1) > Number(elSlide.dataset.page));
    });

    this.slider.dataset.page = page;
    this.setCounterCurrentSlide();

    for (let index = 0; index < this.originalItems.length; index++) {
      const element = this.originalItems[index];
      if (Number(page) === index) {
        const videoElement = element.querySelector('video');
        videoElement && videoElement.play();
        const youtubeElement = element.querySelector('.js-youtube');
        const vimeoElement = element.querySelector('.js-vimeo');
        if (youtubeElement) {
          this.handlePlayVideo(youtubeElement, 'start');
        } else if (vimeoElement) {
          this.handlePlayVideo(vimeoElement, 'start');
        }
      } else {
        const videoElement = element.querySelector('video');
        if (videoElement && !videoElement.paused) {
          videoElement.pause();
        }
        const youtubeElement = element.querySelector('.js-youtube');
        const vimeoElement = element.querySelector('.js-vimeo');
        if (youtubeElement) {
          this.handlePlayVideo(youtubeElement, 'stop');
        } else if (vimeoElement) {
          this.handlePlayVideo(vimeoElement, 'stop');
        }
      }
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = (this.slider.dataset.speed || this.slider.getAttribute('data-speed') || 5) * 1000;

    if (this.sliderAutoplayButton) this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onClickArrow(event) {
    event.stopPropagation();
    const name = event.target?.name || event.target.parentNode?.name || event.target.parentNode?.parentNode?.name;
    if (name == 'next') {
      this.currentPage += 1;
      this.anim();
    } else if (name == 'previous') {
      this.currentPage -= 1;
      this.anim();
    }
  }

  onClickControl(event) {
    const page = event.target.dataset.page || event.target.parentNode.dataset.page || 1;
    this.currentPage = page - 1;
    this.anim();
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (!this.sliderAutoplayButton) return;
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    this.currentPage += 1;
    this.anim();
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton?.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton?.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  handlePlayVideo(element, type) {
    if (!element) return;
    let srcString = element.getAttribute('src');
    if (type === 'start') {
      if (element.getAttribute('src').includes('autoplay=0')) {
        srcString = element.getAttribute('src').replace('autoplay=0', 'autoplay=1');
      }
    } else {
      if (element.getAttribute('src').includes('autoplay=1')) {
        srcString = element.getAttribute('src').replace('autoplay=1', 'autoplay=0');
      }
    }
    if (element.getAttribute('src') != srcString) {
      element.src = srcString;
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ImageWithTextTabsSlider extends SliderComponent {
  constructor() {
    super();
    this.setTabTitle();
  }

  insertTitleAt(str, sub, pos) {
    return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
  }

  extractContent(value) {
    var div = document.createElement('div')
    div.innerHTML = value;
    var text = div.textContent;
    return text;
  }

  setTabTitle() {
    const position = this.slider.getAttribute('data-tab-position');
    const tabTitle = this.currentSliderItem.getAttribute('data-tab-title');
    const nextTabTitle = this.nextSliderItem.getAttribute('data-tab-title');
    const descriptionEle = this.querySelector('.description');
    const descriptionText = this.slider.getAttribute('data-description');
    if (tabTitle && position && descriptionEle && position != '0') {
      const newHTML = this.insertTitleAt(descriptionText.trim(), `<div class="relative"><span class="tab-title next-tab-title">${nextTabTitle}</span><span class="tab-title current-tab-title">${tabTitle}</span></div>`, Number(position));
      // descriptionEle.innerHTML = newHTML;
    }
  }

  update() {
    super.update();
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    event.preventDefault();
    setTimeout(() => {
      const tabTitle = this.currentSliderItem.getAttribute('data-tab-title');
      const nextTabTitleEle = this.querySelector('.next-tab-title');
      const currentTabTitleEle = this.querySelector('.current-tab-title');
      currentTabTitleEle.textContent = tabTitle;
      // currentTabTitleEle.classList = 'tab-title slide-left current-tab-title';
      // nextTabTitleEle.classList = 'tab-title slide-right next-tab-title';
    }, 500);
  }
}

customElements.define('image-with-text-tabs-slider-component', ImageWithTextTabsSlider);

class HeaderGroup extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.elements = {
      extraDetailsBar: this.querySelector('.extra-bar-section') || null,
      announcementBar: this.querySelector('.announcement-bar-section') || null,
      header: this.querySelector('.header-wrapper'),
    };

    document.addEventListener('shopify:section:load', function (event) {
      const isExtraDetailsBar = Boolean(event.target.querySelector('extra-bar-section'));
      const isAnnouncementBar = Boolean(event.target.querySelector('announcement-bar-section'));
      const isHeader = Boolean(event.target.querySelector('header-section'));
      
      const isHeaderGroup = isExtraDetailsBar || isAnnouncementBar || isHeader;
      if (isHeaderGroup) {
        self.initialize();
      }
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      self.initialize();
    }, 150), { passive: true });

    this.initialize();
  }

  initialize() {
    setTimeout(() => {
      this.elements = {
        extraDetailsBar: this.querySelector('.extra-bar-section') || null,
        announcementBar: this.querySelector('.announcement-bar-section .announcement-bar--wrap') || null,
        header: this.querySelector('.header-wrapper'),
      };

      const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          const header = entry.target.querySelector('.header-wrapper');
          const extraDetailsBar = entry.target.querySelector('.extra-bar-section');
          const announcementBar = entry.target.querySelector('.announcement-bar-section .announcement-bar--wrap');
          
          const currentHeight = Math.ceil(header?.clientHeight || 0);
          
          document.documentElement.style.setProperty('--header-height', currentHeight + 'px');
          document.getElementById('MainContent').style.setProperty('--header-height', currentHeight + 'px');
          document.querySelector('header').style.setProperty('--header-height', currentHeight + 'px');
          
          document.getElementById('MainContent').style.setProperty('--extra-details-bar-height', Math.ceil(extraDetailsBar?.clientHeight || 0) + 'px');
          document.getElementById('MainContent').style.setProperty('--announcement-bar-height', Math.ceil(announcementBar?.clientHeight || 0) + 'px');
          const isStickyAnnouncement = document.body.classList.contains('sticky-announcement');
          document.documentElement.style.setProperty(
            '--announcement-bar-sticky-height',
            isStickyAnnouncement ? Math.ceil(announcementBar?.clientHeight || 0) + 'px' : '0px'
          );
          
          window.headerElement = {
            headerHeight: currentHeight,
            extraDetailsBarHeight: extraDetailsBar?.clientHeight || 0,
            announcementBarHeight: announcementBar?.clientHeight || 0
          };
        }
      });
      observer.observe(this);
    }, 0);
  }
};

customElements.define('header-group', HeaderGroup);

class StickyHeader extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.stickyHeader = document.querySelector('sticky-header');
    this.header = document.querySelector('header');

    document.addEventListener('shopify:section:load', function (event) {
      const isStickyHeader = Boolean(event.target.querySelector('sticky-header'));
      if (isStickyHeader) self.initialize();
    });

    this.initialize();
  }

  initialize() {
    const sticky = this.stickyHeader.getAttribute('data-sticky');
    const main = document.getElementById('MainContent');
    if (window.scrollY > this.header.clientHeight) {
      if (sticky == 'always') {
        this.header.querySelector('sticky-header').classList.add('shopify-section-header-sticky');
        document.body.classList.add('enabled-sticky-header');
      }
    } else {
      this.header.classList.remove('shopify-section-header-sticky');
      document.body.classList.remove('enabled-sticky-header');
    }
    
    const headerBanner = document.querySelector('.header-hero-banner-wrapper');
    if (headerBanner && document.body.classList.contains('template-index')) {
      main.classList.add('has-header-banner');
    }
    
    if (document.querySelector('.site-header-transparent-enabled') != null) {
      main.classList.add('has-site-header-transparent');
      this.stickyHeader.classList.add('sticky-transparent');
    } else {
      main.classList.remove('has-site-header-transparent');
    }
  }

  connectedCallback() {
    this.initialize();
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    // OPTIMIZATION: Added passive listener
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.createObserver();
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const sticky = this.stickyHeader.getAttribute('data-sticky');
    const headerSection = this.querySelector('header-section');
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
    const banner = document.querySelector('.header-hero-banner-wrapper');
    let maxOffsetTop = (window.headerElement?.announcementBarHeight || 10) + (window.headerElement?.extraDetailsBarHeight || 10);
    if (banner && window.innerWidth >= 1024) {
      maxOffsetTop += banner.offsetHeight;
    }
    
    // OPTIMIZATION: Use requestAnimationFrame to batch DOM changes
    if (this._rafId) cancelAnimationFrame(this._rafId);
    
    this._rafId = requestAnimationFrame(() => {
      switch (sticky) {
        case 'always':
          if (scrollTop < maxOffsetTop - 10) {
            this.header.querySelector('sticky-header').classList.remove('shopify-section-header-sticky');
            document.body.classList.remove('enabled-sticky-header');
          } else {
            this.header.querySelector('sticky-header').classList.add('shopify-section-header-sticky');
            document.body.classList.add('enabled-sticky-header');
            this.stickyHeader?.classList?.remove('background_transparent');
            if (headerSection) headerSection.classList.remove('site-header-transparent');
          }
          break;
        case 'on_scroll_up':
          if (scrollTop > this.currentScrollTop || scrollTop < maxOffsetTop - 10) {
            this.header.querySelector('sticky-header').classList.remove('shopify-section-header-sticky');
            document.body.classList.remove('enabled-sticky-header');
          } else {
            this.header.querySelector('sticky-header').classList.add('shopify-section-header-sticky');
            document.body.classList.add('enabled-sticky-header');
            this.stickyHeader?.classList?.remove('background_transparent');
            if (headerSection) headerSection.classList.remove('site-header-transparent');
          }
          break;
        default:
          break;
      }

      if (headerSection && headerSection.classList.contains('site-header-transparent-enabled')) {
        if (scrollTop == 0) {
          headerSection.classList.add('site-header-transparent');
          this.stickyHeader?.classList?.add('background_transparent');
        }
      }
    });

    this.currentScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

class StickyAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementBar = document.getElementById("announcement-bar-container");
    this.desktopPosition = this.announcementBar.getAttribute('data-mobile-position');
    this.mobilePosition = this.announcementBar.getAttribute('data-desktop-position');
    this.enableSticky = this.announcementBar.getAttribute('data-sticky-announcement');
    // OPTIMIZATION: Added passive listener
    window.addEventListener('scroll', this.onScrollHandler.bind(this), { passive: true });
    const scrollTop = window.pageYOffset || 
      document.documentElement.scrollTop || 
      document.body.scrollTop || 
      0;
    
    if (this.enableSticky == 'true') {
      document.querySelector('body').classList.add('sticky-announcement');
      if (scrollTop < 50) {
        this.announcementBar.classList.remove('sticky');
      } else {
        this.announcementBar.classList.add('sticky');
      }
    } else {
      document.querySelector('body').classList.remove('sticky-announcement');
    }
  }

  resetPositionHeader() {
    // try {
    //   const stickyHeader = document.querySelector('sticky-header');
    //   if (stickyHeader) {
    //     stickyHeader.style.top = 0;
    //   }
    // } catch (error) {
    //   console.log("Failed to reset header position");
    // }
  }
  onScrollHandler() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.announcementBar = document.getElementById("announcement-bar-container");
    document.body.style.setProperty('--announcement-bar-height', Math.ceil(this.announcementBar?.clientHeight || 0) + 'px');
    if (this.enableSticky == 'true') {
      if (scrollTop < 50) {
        this.announcementBar.classList.remove("sticky");
      } else {
        this.announcementBar.classList.add("sticky");
      }
    }

    const footerEle = document.querySelector('footer');
    const rect = footerEle.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
        this.style.display = 'none';
    } else {
        this.style.display = 'block';
    }
  }
  disconnectedCallback() {
    this.resetPositionHeader();
    window.removeEventListener('scroll', this.handleStickyAnnouncement);
  }
}
customElements.define('sticky-announcement-bar', StickyAnnouncementBar);


class StickyImageWithText extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener('scroll', this.handleStickyImageWithtext, false);
  }
  handleStickyImageWithtext() {
    var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const stickyImageWithText = document.getElementById("sticky-image-with-text");
    const stop = (stickyImageWithText.offsetTop - 60);
    if (scrollTop >= stop) {
      stickyImageWithText.classList.add("sticky-image-with-text");
    } else {
      stickyImageWithText.classList.remove("sticky-image-with-text");
    }
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleStickyImageWithtext);
  }
}
if (!customElements.get('sticky-image-with-text')) { customElements.define('sticky-image-with-text', StickyImageWithText); }


class CollageGrid extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    try {
      const collageGrids = document.querySelectorAll(".collage_layout_wrapper");
      if (collageGrids.length) {
        collageGrids.forEach((el) => {
          var imageEl = el.querySelector(".aspect-square");
          var bodyWidth = document.body.offsetWidth;
          if (bodyWidth >= 750) {
            imageEl.style.maxHeight = imageEl.offsetWidth + 'px';
          }
        })
      }
    } catch (error) {
    }
    this.swatchesController();
  }
  updateMainImage(imageUrl, productId) {
    const productCartVariantImageEle = document.getElementById(`product-card--variant-image-${productId}`);
    if (productCartVariantImageEle && imageUrl) {
      productCartVariantImageEle.style.display = 'block';
      productCartVariantImageEle.style.backgroundImage = `url(${imageUrl})`
    }
  }

  onMouseLeaveColorSwatches(productId) {
    const productCartVariantImageEle = document.getElementById(`product-card--variant-image-${productId}`);
    if (productCartVariantImageEle) productCartVariantImageEle.style.display = 'none';
  }
  swatchesController() {
    const swatchesItem = document.querySelectorAll('.swatches-item');
    for (let index = 0; index < swatchesItem.length; index++) {
      const element = swatchesItem[index];
      element.addEventListener('mouseover', (e) => {
        const self = e;
        const swatchImage = self.target.getAttribute('data-image');
        const productId = self.target.getAttribute('data-product-id');
        this.updateMainImage(swatchImage, productId);
      });

      element.addEventListener('mouseleave', (e) => {
        const self = e;
        const productId = self.target.getAttribute('data-product-id');
        this.onMouseLeaveColorSwatches(productId);
      });
    }
  }
  disconnectedCallback() {
  }
}
if (!customElements.get('collage-grid')) { customElements.define('collage-grid', CollageGrid); }

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"], input[name="language_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    if (this.elements.button) this.elements.button.addEventListener('click', this.openSelector.bind(this));
    if (this.elements.button) this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    
    // ADD BOTH CLICK AND KEYDOWN LISTENERS
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', this.onItemClick.bind(this));
      item.addEventListener('keydown', this.onItemKeyDown.bind(this)); // ← NEW!
    });
  }

  hidePanel() {
    if (this.elements.button) this.elements.button.setAttribute('aria-expanded', 'false');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    if (this.elements.button) this.elements.button.focus();
  }
  
  // Handle keyboard navigation
  onItemKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onItemClick(event);
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    
    if (this.elements && this.elements.input) {
      this.elements.input.value = event.currentTarget.dataset.value;
    }
    
    setTimeout(() => {
      if (form) form.submit();
    }, 500);
  }

  openSelector() {
    if (this.elements.button) this.elements.button.focus();
    if (this.elements.button)
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    if (this.elements.panel) this.elements.panel.toggleAttribute('hidden');
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);

class Pagination extends HTMLElement {
  constructor() {
    super();
    this.totalPages = Number(this.getAttribute('data-total-page') || 0);
    this.currentPage = Number(this.getAttribute('data-current-page') || 0);
    this.limitPage = Number(this.getAttribute('data-limit-page') || 0);
    this.pages = this.querySelector('.pagination-pages');
    this.start = 1;
    this.init();
  }

  init() {
    this.rebuildPagination(this.start, this.totalPages);
  }

  rebuildPagination(currentPage, totalcount) {
    var HTML = "";

    if (this.totalPages <= this.limitPage) {
      for (i = 1; i <= totalcount; i++) {
        HTML += this.addButton(i, currentPage);
      }
    } else {
      HTML += this.addButton("1", currentPage);
      if (currentPage > 3) {
        HTML += "<li class='pagination-item'>...</li>";
      }

      if (currentPage == totalcount) {
        HTML += this.addButton(currentPage - 2, currentPage);
      }

      if (currentPage > 2) {
        HTML += this.addButton(currentPage - 1, currentPage);
      }

      if (currentPage != 1 && currentPage != totalcount) {
        HTML += this.addButton(currentPage, currentPage);
      }

      if (currentPage < totalcount - 1) {
        HTML += this.addButton(currentPage + 1, currentPage);
      }

      if (currentPage == 1) {
        HTML += this.addButton(currentPage + 2, currentPage);
      }

      if (currentPage < totalcount - 2) {
        HTML += "<li class='pagination-item'>...</li>";
      }

      if (totalcount > 1) {
        HTML += this.addButton(totalcount, currentPage);
      }
    }

    this.pages.innerHTML = HTML;
    this.items = this.pages.querySelectorAll('.pagination-item');
    this.items.forEach(i => i.addEventListener('click', this.handlevent.bind(this, i)));
  }

  addButton(number, currentPage) {
    var item = document.createElement('li');
    item.className = 'pagination-item';
    item.setAttribute('data-page', number)
    if (number == currentPage) {
      item.classList.add('active');
    }

    // Add button number
    item.innerText = number;

    // return string
    return item.outerHTML;
  }

  handlevent(item) {
    const page = item.getAttribute('data-page');
    this.start = Number(page);
    this.currentPage = Number(page);
    this.rebuildPagination(this.start, this.totalPages);
  }

}
if (!customElements.get('pagination-element')) customElements.define('pagination-element', Pagination);

class Alert {
  constructor() {
    this.alertElement = document.querySelector('alert-message') || document.querySelector('.alert__message');
  }

  show(options = {}) {
    const {
      id = "",
      content = "",
      timeout = 3000,
    } = options;
    this.alertElement = document.querySelector('alert-message') || document.querySelector('.alert__message');

    if (!this.alertElement) return;

    this.alertElement.classList.remove('hidden');
    this.alertElement.innerHTML = content;

    if (id) this.alertElement.id = id;

    setTimeout(() => {
      this.alertElement.classList.add('hidden');
    }, timeout);
  }
}

window.Alert = new Alert();

if (!customElements.get("video-banner")) {
  customElements.define(
    'video-banner',
    class VideoBanner extends HTMLElement {
      constructor() {
        super();
        const seft = this;
        this.videoContent = this.querySelector('.video-banner__content');
        this.init();

        document.addEventListener('shopify:section:load', function (event) {
          seft.init();
        });

        // OPTIMIZATION: Debounced resize handler with passive listener
        window.addEventListener('resize', debounce(() => {
          seft.init();
        }, 150), { passive: true });
      }

      init() {
        const videoContentHeight = this.imageCard?.clientHeight || 200;

        this.style.setProperty('--card-min-height', `${videoContentHeight + 50}px`);
      }
    }
  );
}

class ImageContentGrid extends HTMLElement {
  constructor() {
    super();
    const seft = this;
    this.init();

    document.addEventListener('shopify:section:load', function (event) {
      const grids = event.target.querySelectorAll('image-content-grid');
      grids.forEach(element => {
        element.init();
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      const sectionHasImageContentGrid = Boolean(event.target.querySelector('image-content-grid') || event.target.closest('image-content-grid'));
      
      if (!sectionHasImageContentGrid) return;
      seft.init();
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      seft.init();
    }, 150), { passive: true });
  }

  init() {
    setTimeout(() => {
      this.gridContent = this.querySelector('.grid-item__content');
      const contentHeight = this.gridContent?.clientHeight || 200;
      
      this.style.setProperty('--content-height', `${contentHeight}px`);
      this.style.setProperty('--card-min-height', `${contentHeight}px`);
    }, 300);
  }
}

if (!customElements.get('image-content-grid')) customElements.define('image-content-grid', ImageContentGrid);

if (!customElements.get("image-banner")) {
  customElements.define(
    'image-banner',
    class ImageBanner extends HTMLElement {
      constructor() {
        super();
        const seft = this;
        this.imageContent = this.querySelector('.banner__content');
        this.imageBanner = this.querySelector('.animations-parallax_effect .banner__media');
        this.addEventListener('click', function(e) {
          const imageURL = this.getAttribute('data-image-url');
          if (imageURL) window.location.href = imageURL;
        });

        if (this.imageContent) this.imageContent.addEventListener('click', function(e) {
          //e.preventDefault();
          //e.stopPropagation();
        });
        this.init();

        document.addEventListener('shopify:section:load', function (event) {
          const isImageBannerSection = Boolean(event.target.querySelector('image-banner'));
          if (isImageBannerSection) seft.init();
        });

        // OPTIMIZATION: Debounced resize handler with passive listener
        window.addEventListener('resize', debounce(() => {
          seft.init();
        }, 150), { passive: true });
      }

      init() {
        const contentHeight = this.imageContent?.clientHeight || 200;

        this.style.setProperty('--image-min-height', `${contentHeight}px`);
      }
    }
  );
}

class SectionGrid extends HTMLElement {
  constructor() {
    super();
    const seft = this;
    this.init();

    document.addEventListener('shopify:section:load', function (event) {
      const isSelectorection = Boolean(event.target.querySelector('section-grid'));
      if (isSelectorection) seft.init();
    });

    document.addEventListener('shopify:block:select', function (event) {
      seft.init();
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      seft.init();
    }, 150), { passive: true });
  }

  init() {
    setTimeout(() => {
      this.gridContent = this.querySelectorAll('.grid__image-content');
      let contentHeight = 0;
      if (this.gridContent) {
        this.gridContent.forEach(content => {
          if (content?.clientHeight > contentHeight) {
            contentHeight = content.clientHeight;
          }
        })
      }

      this.style.setProperty('--content-height', `${contentHeight}px`);
    }, 0);
  }
}

if (!customElements.get('section-grid')) customElements.define('section-grid', SectionGrid);

class VideoWithText extends HTMLElement {
  constructor() {
    super();
    const seft = this;
    this.init();

    document.addEventListener('shopify:section:load', function (event) {
      const isSelectorection = Boolean(event.target.querySelector('video-with-text'));
      if (isSelectorection) seft.init();
    });

    document.addEventListener('shopify:block:select', function (event) {
      seft.init();
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      seft.init();
    }, 150), { passive: true });
  }

  init() {
    setTimeout(() => {
      this.gridContent = this.querySelector('.image-with-text__text-item');
    
      const contentHeight = this.gridContent?.clientHeight;

      this.style.setProperty('--content-height', `${contentHeight}px`);
    }, 0);
  }
}

if (!customElements.get('video-with-text')) customElements.define('video-with-text', VideoWithText);

class InfinityScrollSlider extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.container = this.querySelector('.scroll-container');
    this.scrollSide = 'right';
    this.initItems = this.container.querySelectorAll('.scroll-item');
    if (!this.container) return;

    document.addEventListener('shopify:section:load', function (event) {
      const infinityScroll = event.target.querySelectorAll('infinity-scroll-element');
      infinityScroll.forEach(element => {
        element.init();
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      self.init();
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      this.init();
    }, 150), { passive: true });

    this.init();

  }

  hideCloneItems() {
    const cloneItems = this.container.querySelectorAll('.clone-item');
    const elementsArray = Array.from(cloneItems);
    elementsArray.forEach(function(element) {
      element.style.display = 'none';
    });
  }

  showCloneItems() {
    const cloneItems = this.container.querySelectorAll('.clone-item');
    const elementsArray = Array.from(cloneItems);
    elementsArray.forEach(function(element) {
      element.removeAttribute('style');
    });
  }

  init() {
    this.container = this.querySelector('.scroll-container');
    this.scrollOnMobile = Boolean(this.getAttribute('data-scroll-on-mobile') == 'true');
    this.scrollOnDesktop = Boolean(this.getAttribute('data-scroll-on-desktop') == 'true');
    const items = this.container.querySelectorAll('.scroll-item');
    this.enable = this.getAttribute('data-enable');
    if (this.enable && this.enable == 'false') return;
    
    const hasHorizontalScroll = this.container.scrollWidth > this.container.clientWidth;
    const hasVerticalScroll = this.container.scrollHeight > this.container.clientHeight;
    items.forEach(element => {
      element.addEventListener('click', this.onClickItem.bind(this));
    });
    this.firstChildWidth = items.length > 0 ? items[0].clientWidth : 0;
    
    this.container.addEventListener('mousedown', this.containerMouseDown.bind(this));
    this.container.addEventListener('mouseleave', this.containerMouseLeave.bind(this));
    this.container.addEventListener('mousemove', this.containerMouseMove.bind(this));
    this.container.addEventListener('mouseup', () => {
      this.isDown = false;
      this.container.classList.remove('active');
    });

    // OPTIMIZATION: Added passive listener and debounced
    this.container.addEventListener('scroll', debounce(this.containerScroll.bind(this), 0), { passive: true });
  }

  onClickItem(e) {
    const itemEle = e.target.closest('.scroll-item');
    this.dispatchEvent(new CustomEvent('onClickScrollItem', {
      detail: {
        item: itemEle,
        container: this.container
      }
    }));
  }

  containerMouseDown(e) {
    this.isDown = true;
    this.container.classList.add('active');
    this.startX = e.pageX - this.container.offsetLeft;
    this.scrollLeft = this.container.scrollLeft;
  }

  containerMouseLeave(e) {
    this.isDown = false;
    this.container.classList.remove('active');
  }

  containerMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.container.offsetLeft;
    const walk = (x - this.startX) * 2; // adjust scroll speed
    
    this.container.scrollLeft -= walk;
    if (walk > 0) {
      this.scrollSide = 'left';
    } else {
      this.scrollSide = 'right';
    }
  }

  containerScroll(e) {
    this.container = this.querySelector('.scroll-container');
    const distance = this.container.scrollWidth - (this.container.scrollLeft + this.container.clientWidth);
    const items = this.container.querySelectorAll('.scroll-item');
    const count = this.container.getAttribute('data-count');
    
    if (this.scrollSide == 'right' && distance == 0) {
      const currentIndex = Number(items[items.length - 1]?.getAttribute('data-index') || '1');
      let nextIndex = 1;
      if (currentIndex < count) {
        nextIndex = currentIndex + 1;
      }
      const nextItems = this.container.querySelectorAll(`.scroll-item__${nextIndex}`);
      
      this.container.style.scrollBehavior = "auto";
      let middleItem = nextItems[0]; 
      if (nextItems.length > 1) {
        const middleIndex = Math.floor(nextItems.length / 2);
        middleItem = nextItems[middleIndex];
      }
      this.container.scrollLeft = middleItem.offsetLeft;
      requestAnimationFrame(() => {
        this.container.style.scrollBehavior = "smooth";
      });
    }
  }
}

if (!customElements.get('infinity-scroll-element')) customElements.define('infinity-scroll-element', InfinityScrollSlider);

class ScrollingComponent extends HTMLElement {
  constructor() {
    super();
    const self = this;

    document.addEventListener('shopify:section:load', function (event) {
      self.init();
    });

    document.addEventListener('shopify:block:select', function (event) {
      const components = event.target.querySelectorAll('scrolling-component');
      components.forEach(element => {
        element.init();
      });
    });

    // OPTIMIZATION: Debounced resize handler with passive listener
    window.addEventListener('resize', debounce(() => {
      this.init();
    }, 150), { passive: true });

    document.addEventListener("DOMContentLoaded", function () {
      self.init();
    });

  }

  init() {
    this.style.animationPlayState = "paused";
    setTimeout(() => {
      const containerWidth = this.clientWidth;
      const clientWidth = Math.round(document.body.clientWidth);
      let speed = (this.getAttribute('data-speed') || 10) * 1;
      
      const count = this.dataset.count || this.getAttribute('data-count') || 1;
      const isPauseWith1Element = this.getAttribute('data-pause-when-only') || 'false';

      if (isPauseWith1Element == 'true' && count == 1) return;
      if (!Number.isInteger(speed)) {
        speed = 10;
      }
      const totalSpeed = Math.round(containerWidth / clientWidth) * speed;
      
      this.style.setProperty('--marquee-speed', `${speed}s`);
      
      this.style.animationPlayState = "running";
    }, 0);
  }
}
if (!customElements.get('scrolling-component')) customElements.define('scrolling-component', ScrollingComponent);

class ProductCardSwatch extends HTMLElement {
  constructor() {
    super();
    this.swatchElement = this.querySelector('.has-image');
    
    if (!this.swatchElement) return;
    this.cartContainer = this.closest('.product-card-information');
    this.swatchImage = this.closest('.product-card-information')
                      ?.querySelector('.product-media .swatch-image');
    this.featuredImage = this.closest('.product-card-information').querySelector('.product-featured__image img');
    this.dataURL = this.swatchElement.dataset.value;
    if (!this.swatchImage || !this.dataURL) return;
    
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.initialize();
  }

  initialize() {
    this.swatchElement.addEventListener('mouseenter', this.handleMouseEnter);
    this.swatchElement.addEventListener('mouseleave', this.handleMouseLeave);
  }

  handleMouseEnter() {
    this.cartContainer.classList.add('show-swatch-image');
    this.swatchImage.classList.add('active');
    this.swatchImage.style.setProperty('--swatch-background-url', this.dataURL);
  }

  handleMouseLeave() {
    this.cartContainer.classList.remove('show-swatch-image');
    this.swatchImage.classList.remove('active');
    this.swatchImage.style.removeProperty('--swatch-background-url');
  }

  disconnectedCallback() {
    this.swatchElement?.removeEventListener('mouseenter', this.handleMouseEnter);
    this.swatchElement?.removeEventListener('mouseleave', this.handleMouseLeave);
  }
}

// Product Card Swatch Handler
if (!customElements.get('product-card-swatch')) {
  customElements.define('product-card-swatch', class ProductCardSwatch extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      
      if (!link) return;
      
      this.style.cursor = 'pointer';
      
      this.addEventListener('click', (e) => {

        if (e.target === link) return;
        
        e.stopPropagation();
        e.preventDefault();

        this.blur();
        
        window.location.href = link.href;
      });
      
      // Keyboard support
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          link.click();
        }
      });
    }
  });
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', class ProductCard extends HTMLElement {
    constructor() {
      super();
      const productURL = this.getAttribute('data-url');
      this.addEventListener('click', function(e) {
        if (e.target.closest('quick-add-button')) return;
        if (e.target.closest('product-card-swatch')) return;
        
        window.location.href = productURL;
      });
    }
  });
}

class FormCheckbox extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');

    if (!this.input) return
    this.input.addEventListener('change', this.onChangeInput.bind(this));
  }

  onChangeInput(e) {
    const checked = e.target.checked;
    const checked_value = this.getAttribute('data-checked') || this.querySelector('.checked_value')?.textContent || '';
    const unchecked_value = this.getAttribute('data-unchecked') || this.querySelector('.unchecked_value')?.textContent || '';
    const formGroup = this.input.closest('.form__groups-checkbox');
    if (formGroup) formGroup.classList.remove('error');
    if (checked) {
      this.input.value = checked_value;
    } else {
      this.input.value = unchecked_value;
    }
  }
}
if (!customElements.get('form-checkbox')) customElements.define('form-checkbox', FormCheckbox);

class FormRadios extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach(input => {
      input.addEventListener('change', this.onChangeInput.bind(this));
    });
  }

  onChangeInput(e) {
    this.classList.remove('error');
  }
}

if (!customElements.get('form-radios')) customElements.define('form-radios', FormRadios);

//if (!customElements.get('product-card')) {
//  customElements.define('product-card', class ProductCard extends HTMLElement {
//    constructor() {
//      super();
//      const productURL = this.getAttribute('data-url');
//      this.addEventListener('click', function(e) {
//        if (e.target.closest('quick-add-button'))  return;
//        window.location.href = productURL;
//      });
//    }
//  });
//}

document.addEventListener('DOMContentLoaded', (event) => {
  // Add to cart
  const btnAddToCart = document.querySelectorAll('.button-add-to-cart');
  btnAddToCart.forEach((btn) => {
    btn.addEventListener('click', function () {
      const formAddToCart = btn.closest('.product-card-information').querySelector('.form-add-to-cart');
      if (formAddToCart) formAddToCart.submit();
    });
  });

  var quickOptions = document.querySelectorAll('.button-quick-options');
  quickOptions.forEach((quickOption) => {
    quickOption.addEventListener('click', function () {
      var handle = quickOption.getAttribute('data-handle');
      var link = '/products/' + handle;
      fetch(link)
        .then(res => res.text())
        .then(html => {
          var parser = new DOMParser();
          var productElement = parser.parseFromString(html, "text/html");
          if (productElement == null) {
            return 0;
          }
          var productContent = productElement.querySelector('.shopify-section.product-section');
          if (productContent.querySelector('.sticky-addtocart-wrapper')) productContent.querySelector('.sticky-addtocart-wrapper').remove();
          const quickOptionElement = document.getElementById('quick-options-drawer');
          if (quickOptionElement == null) {
            const quickOption = document.createElement('div');
            const quickOptionInner = document.createElement('div');
            quickOptionInner.classList.add('quick-options-drawer-inner');
            const quickOptionOverlap = document.createElement('div');
            quickOptionOverlap.classList.add('quick-options-drawer-overlay');
            const quickOptionClose = document.createElement('div');
            quickOptionClose.classList.add('quick-options-drawer-close');
            quickOption.setAttribute('id', 'quick-options-drawer');
            quickOption.classList.add('quick-options-drawer');
            quickOption.appendChild(quickOptionInner);
            quickOption.appendChild(quickOptionOverlap);
            quickOption.appendChild(quickOptionClose);
            document.querySelector('body').appendChild(quickOption);
            document.querySelector('.quick-options-drawer-close').addEventListener('click', function () {
              document.getElementById('quick-options-drawer').classList.remove('open');
              document.querySelector('body').classList.remove('quick-options-open');
            });
            document.querySelector('.quick-options-drawer-overlay').addEventListener('click', function () {
              document.getElementById('quick-options-drawer').classList.remove('open');
              document.querySelector('body').classList.remove('quick-options-open');
            });
          } else {
            quickOptionElement.querySelector('.quick-options-drawer-inner').innerHTML = '';
          }
          const quickOptionDrawer = document.getElementById('quick-options-drawer');
          if (productContent != null && quickOptionDrawer != null) {
            if (productContent.querySelector('variant-radios')) {
              productContent.querySelector('variant-radios').setAttribute('data-update-url', 'false');
            }
            if (productContent.querySelector('variant-selects')) {
              productContent.querySelector('variant-selects').setAttribute('data-update-url', 'false');
            }
            if (productContent.querySelector('.slider--mobile')) {
              productContent.querySelectorAll('.slider--mobile').forEach((mobileSlider) => {
                mobileSlider.classList.add('slider--tablet-up');
              });
            }
            quickOptionDrawer.querySelector('.quick-options-drawer-inner').appendChild(productContent);
            quickOptionDrawer.classList.add('open');
            document.querySelector('body').classList.add('quick-options-open');
            Shopify.PaymentButton.init();

            setTimeout(function () {
              const buyItNow = quickOptionDrawer.querySelector('.shopify-payment-button__button');
              if (buyItNow != null) {
                buyItNow.removeAttribute('disabled');
                buyItNow.addEventListener('click', function (evt) {
                  evt.preventDefault();
                  var form = buyItNow.closest('form');

                  const config = fetchConfig('javascript');
                  config.headers['X-Requested-With'] = 'XMLHttpRequest';
                  delete config.headers['Content-Type'];

                  const formData = new FormData(form);
                  formData.append('sections_url', window.location.pathname);
                  config.body = formData;

                  fetch('/cart/clear.js')
                    .then((response) => {
                      fetch(`${routes.cart_add_url}`, config)
                        .then((response) => response.json())
                        .then((response) => {
                          if (response.status) {
                            //this.handleErrorMessage(response.description);
                            return;
                          }
                          if (document.querySelector('.quick-options-drawer.open') != null) {
                            document.querySelector('.quick-options-drawer.open').classList.remove('open');
                          }
                          //this.cartNotification.renderContents(response);
                        })
                        .catch((e) => {
                          console.error(e);
                        })
                        .finally(() => {
                          window.location.href = "/checkout";
                          //submitButton.classList.remove('loading');
                          //submitButton.removeAttribute('aria-disabled');
                          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                        });
                    });
                });
              }
            }, 1000);
          }
        });
    });
  });
});

class SlideUpImages extends HTMLElement {
  constructor() {
    super();
    
    this.init();
  }

  init() {
    this.container = this.querySelector('.slide-up-images-container');
    this.images = this.querySelectorAll('img');
    this.duration = this.getAttribute('data-duration') || 3;
    if (this.images < 2 || !this.container) return;
    const imagesDuration = this.duration * this.images.length;
    this.container.style.setProperty('--slide-up-images-duration', `${imagesDuration}s`);
    this.images.forEach((img, index) => {
      img.style.animationDelay = `${this.duration * index}s`;
    });
  }
}

if (!customElements.get('slide-up-images')) {
  customElements.define('slide-up-images', SlideUpImages);
}

function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

// OPTIMIZATION: Updated to use cached body
function checkScreenWidth() {
  const body = DOMCache.getBody();
  const clientWidth = Math.round(body.clientWidth);
  const isDevice = adjustLayoutForDevice();
  const pageWidth = body.getAttribute('data-width');

  if (isDevice == 'mobile') {
    document.documentElement.style.setProperty('--padding-page-width', `16px`);
  }

  if (isDevice == 'tablet') {
    document.documentElement.style.setProperty('--padding-page-width', `30px`);
  }

  if (isDevice == 'desktop') {
    if (clientWidth < Number(pageWidth)) {
      document.documentElement.style.setProperty('--padding-page-width', `50px`);
    } else {
      if (clientWidth <= Number(pageWidth) + 100) {
        document.documentElement.style.setProperty('--page-width', `${clientWidth - 100}px`);
      }
      document.documentElement.style.setProperty('--padding-page-width', `0px`);
    }
  }
}

function checkHeightHederGroup() {
  const headerGroup = document.querySelectorAll('.shopify-section-group-header-group');
  let heightHeaderGroup = 0;
  for (let index = 0; index < headerGroup.length; index++) {
    const element = headerGroup[index];
    heightHeaderGroup += element.clientHeight;
  }
  
  document.documentElement.style.setProperty('--header-group-height', `${Math.round(heightHeaderGroup)}px`);
}

function checkFooterElement() {
  const isDevice = adjustLayoutForDevice();
  if (isDevice != 'mobile') {
    const collapseElements = document.querySelectorAll('.footer--block collapse-element');
    collapseElements.forEach(element => {
      if (!element.hasAttribute('open')) {
        element.setAttribute('open', '');
      }
    });
  }
}

function loadingImages(root = document) {
  root.querySelectorAll('.media.loading img, img[loading="lazy"]').forEach(img => {
    img.onload = function() {
      const mediaParent = img.closest('.media.loading');
      if (mediaParent) {
        mediaParent.classList.remove('loading');
        mediaParent.classList.add('loaded');
      }
      if (img.parentElement) {
        img.parentElement.classList.remove('loading');
        img.parentElement.classList.add('loaded');
      }
      img.classList.add('loaded');
    }
    img.onerror = function() {}
    if (img.complete) {
      img.onload();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  loadingImages();

  // OPTIMIZATION: Debounced mutation observer
  const observer = new MutationObserver(debounce(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // element
          loadingImages(node);
        }
      });
    });
  }, 100));

  observer.observe(document.body, { childList: true, subtree: true });
});

function moveAllDialogFromMainToBody() {
  const dialogs = document.querySelectorAll('main modal-dialog');
  const dialogsInHeader = document.querySelectorAll('header-group modal-dialog');
  
  dialogs.forEach(dialog => {
    document.body.appendChild(dialog); 
  });

  dialogsInHeader.forEach(dialog => {
    document.body.appendChild(dialog); 
  });
}

// SKIP LINK HANDLER
function initializeSkipToContent() {
  const skipLink = document.querySelector(
    '.skip-to-content-link, ' +
    'a[href="#MainContent"], ' +
    '.visually-hidden[href^="#Main"]'
  );
  
  if (skipLink) {
    skipLink.addEventListener('click', (e) => {
      e.preventDefault();
      const main = document.getElementById('MainContent');
      
      if (main) {
        // Temporarily make focusable
        main.setAttribute('tabindex', '-1');
        main.focus();
        
        // Clean up when focus moves away
        const cleanup = () => {
          main.removeAttribute('tabindex');
        };
        
        main.addEventListener('blur', cleanup, { once: true });
        
        // Safety: Also remove after 100ms
        setTimeout(cleanup, 100);
      }
    });
  }
}

function setStylePaymentTerms() {
  const termsList = document.querySelectorAll("shopify-payment-terms");
  
  termsList.forEach((terms) => {
    // Đợi shadowRoot render xong
    const applyStyles = () => {
      if (!terms.shadowRoot) return;

      // Đổi màu chữ
      const textEl = terms.shadowRoot.querySelector("p, span, div");
      if (textEl) {
        // textEl.style.color = "#000"; // text đen
      }

      // Đổi màu logo Shop Pay
      const svgEl = terms.shadowRoot.querySelector("svg");
      if (svgEl) {
        svgEl.style.color = "#5a31f4"; // tím primary
      }
    };

    // Thử áp dụng ngay
    applyStyles();

    // Nếu Shopify render chậm → theo dõi thêm
    const observer = new MutationObserver(() => applyStyles());
    observer.observe(terms, { childList: true, subtree: true });
  });
}

function checkLinks() {
  const shopifyDomains = ["shopify.com", "myshopify.com", "apps.shopify.com"];
  document.querySelectorAll("a[href]").forEach(link => {
    const href = link.getAttribute("href");
    if (!href) return;

    if (shopifyDomains.some(domain => href.includes(domain))) {
      const rel = link.getAttribute("rel");
      if (!rel || !rel.includes("nofollow")) {
        link.setAttribute("rel", (rel ? rel + " nofollow" : "nofollow").trim());
      }
    }
  });
}

window.onload = () => {
  document.body.classList.add('loaded');
  checkHeightHederGroup();
  checkScreenWidth();
  moveAllDialogFromMainToBody();
  setStylePaymentTerms();
  checkLinks();
  initializeSkipToContent();
};

document.addEventListener('shopify:section:load', function (event) {
  checkScreenWidth();
  checkHeightHederGroup();
  loadingImages();
  moveAllDialogFromMainToBody();
  setStylePaymentTerms();
});

// OPTIMIZATION: Debounced resize handler with passive listener
window.addEventListener('resize', debounce(() => {
  const body = DOMCache.getBody();
  document.documentElement.style.setProperty('--window-width', `${Math.round(body.clientWidth)}px`);
  document.documentElement.style.setProperty('--window-height', `${Math.round(screen.availHeight || screen.height)}px`);
  checkScreenWidth();
  checkHeightHederGroup();
  checkFooterElement();
}, 150), { passive: true });

window.addEventListener('DOMContentLoaded', () => {
  // Check event listeners mega menu click outside
  document.body.addEventListener('click', (event) => {
    if (event.target.closest('.mega-menu') != null) {
    } else {
      if (document.querySelector('details.mega-menu[open]') != null) {
        document.querySelector('details.mega-menu[open]').closest('.header-wrapper').classList.remove('mega-menu-opened');
        document.querySelector('details.mega-menu[open]').removeAttribute('open');
      }
    }
    if (event.target.closest('.menu-drawer-container') != null) {
    } else {
      if (document.querySelector('details.menu-drawer-container[open]') != null) {
        document.querySelector('details.menu-drawer-container[open] summary[aria-controls="menu-drawer"]').click();
      }
    }
  });
});


/* PAGE TRANSITION ANIMATION */
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('loading');
  document.body.classList.add('loaded');
  const body = DOMCache.getBody();
  document.documentElement.style.setProperty('--window-width', `${Math.round(body.clientWidth)}px`);
  document.documentElement.style.setProperty('--window-height', `${Math.round(screen.availHeight || screen.height)}px`);

  var anchors = document.querySelectorAll('a[href]:not([href^="#"]):not([data-modal-opener])');
  for (var idx = 0; idx < anchors.length; idx += 1) {
    if (anchors[idx].hostname !== window.location.hostname) {
      continue;
    }
    if (document.querySelector('cart-drawer') && anchors[idx].pathname.indexOf('/cart') != -1) {
      continue;
    }
    if (anchors[idx].classList.contains('button--cart-item-remove')) {
      continue;
    }
    if (anchors[idx].getAttribute('href') == '#' || anchors[idx].getAttribute('href') == '') {
      continue;
    }
    anchors[idx].addEventListener('click', function (event) {
      if (window.Shopify && window.Shopify.designMode) return;
      if (this.target === '_blank' || event.ctrlKey || event.metaKey || event.shiftKey) return;
      document.body.classList.add('unloading');
    });
  }
});

window.onbeforeunload = function (event) {
  document.body.classList.add('unloading');
};
window.addEventListener("pageshow", function (event) {
   requestAnimationFrame(() => {
    document.body.classList.remove('unloading');
  });
});

/* PAGE SECTIONS REVEAL ON SCROLL ANIMATION */
(() => {
  if (!document.body.classList.contains('reveal-section-on-scroll')) return;

  const OFFSET = 6;

  function initRevealSections(root = document) {
    const sections = root.querySelectorAll('.content-for-layout section.shopify-section:not(.reveal-init)');
    sections.forEach(section => {
      section.classList.add('reveal-init', 'reveal-hidden');

      const items = section.querySelectorAll('.grid__item, .video-item');
      items.forEach((item, i) => {
        item.classList.add('reveal-hidden');
        item.style.transitionDelay = `${i * 100}ms`;
      });
    });

    observeElements(root);
  }

  function observeElements(root = document) {
    const targets = root.querySelectorAll('.reveal-hidden');
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
          entry.target.classList.remove('reveal-hidden');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: `0px 0px -${OFFSET}px 0px`,
      threshold: 0
    });

    targets.forEach(el => observer.observe(el));
  }

  initRevealSections();

  // Theme Editor: re-init when a section is added or updated
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section.matches || !section.closest('.content-for-layout')) return;

    // Mark as already visible in the editor (no animation on settings change)
    section.classList.remove('reveal-hidden');
    section.classList.add('reveal-init', 'reveal-visible');

    const items = section.querySelectorAll('.grid__item, .video-item');
    items.forEach(item => {
      item.classList.remove('reveal-hidden');
      item.classList.add('reveal-visible');
    });
  });
})();

/* ANIMATION LAZYLOAD IMAGES */
document.addEventListener('DOMContentLoaded', () => {
  const DEBUG = false; 
  const SELECT_IMG = 'img[loading="lazy"], img[data-src], img.lazy';

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECT_IMG).forEach(img => {
      const p = img.closest('.grid__item') || img.parentElement || img;
      if (p) p.classList.add('show-image');
    });
    return;
  }

  const observed = new WeakSet();
  const fired = new WeakSet();

  // IntersectionObserver
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const target = entry.target;
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        if (!target.classList.contains('show-image')) {
          target.classList.add('show-image');
          if (DEBUG) console.log('show-image added for', target);
        }
        fired.add(target);
        io.unobserve(target);
        if (resizeObserver) resizeObserver.unobserve(target);
      } else {
        if (DEBUG) console.log('not intersecting yet', target, entry.intersectionRatio);
      }
    });
  }, {
    threshold: [0, 0.01, 0.2],
    //rootMargin: '200px 0px 200px 0px' // trigger before scroll
  });

  // ResizeObserver
  const resizeObserver = ('ResizeObserver' in window) ? new ResizeObserver(entries => {
    entries.forEach(e => {
      const t = e.target;
      const cr = e.contentRect;
      if (cr.width > 0 && cr.height > 0 && !observed.has(t) && !fired.has(t)) {
        observed.add(t);
        io.observe(t);
        if (DEBUG) console.log('Resize -> now observing', t);
      }
    });
  }) : null;

  function getParentTarget(img) {
    return (img && (img.closest('.grid__item') || img.closest('.media') || img.parentElement)) || img;
  }

  function observeParent(parent) {
    if (!parent || observed.has(parent) || fired.has(parent)) return;
    observed.add(parent);
    io.observe(parent);
    if (resizeObserver) resizeObserver.observe(parent);
    if (DEBUG) console.log('start observing parent', parent);
  }

  function processNode(node) {
    if (node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECT_IMG)) {
      observeParent(getParentTarget(node));
    }
    if (node.querySelectorAll) {
      node.querySelectorAll(SELECT_IMG).forEach(img => observeParent(getParentTarget(img)));
    }
    if (node.matches && (node.matches('.grid__item') || node.querySelector(SELECT_IMG))) {
      observeParent(node);
    }
  }

  document.querySelectorAll(SELECT_IMG).forEach(img => observeParent(getParentTarget(img)));

  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.type === 'childList') {
        m.addedNodes.forEach(node => processNode(node));
      } else if (m.type === 'attributes') {
        // attribute thay đổi trên element -> re-check
        processNode(m.target);
      }
    });
  });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style','data-src','src','loading'] });

  let attempts = 0, maxAttempts = 8;
  const fallback = setInterval(() => {
    attempts++;
    document.querySelectorAll(SELECT_IMG).forEach(img => observeParent(getParentTarget(img)));
    if (attempts >= maxAttempts) clearInterval(fallback);
  }, 600);
});

// ===== AUTO-PAUSE VIDEOS WHEN SWITCHING MEDIA =====

document.addEventListener('DOMContentLoaded', () => {
  
  // Function to pause and reset all videos
  function pauseAndResetAllVideos() {
    // Pause all HTML5 videos and reset to start
    document.querySelectorAll('video').forEach(video => {
      if (!video.paused) {
        video.pause();
      }
      video.currentTime = 0; // Reset to beginning
    });
    
    // Pause external videos (YouTube/Vimeo)
    document.querySelectorAll('.media-video-external iframe').forEach(iframe => {
      try {
        // YouTube
        iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        // Vimeo
        iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
      } catch(e) {
        // Ignore cross-origin errors
      }
    });
  }
  
  // Listen for thumbnail/media navigation clicks
  const mediaElements = document.querySelectorAll('.product__media-item, .thumbnail, [data-media-id]');
  mediaElements.forEach(element => {
    element.addEventListener('click', () => {
      pauseAndResetAllVideos();
    });
  });
  
  // Listen for slider/carousel changes
  const sliders = document.querySelectorAll('.slider, .flickity-enabled, [class*="carousel"]');
  sliders.forEach(slider => {
    slider.addEventListener('change', pauseAndResetAllVideos);
    slider.addEventListener('slideChange', pauseAndResetAllVideos);
  });
  
  // Listen for variant changes
  const variantSelectors = document.querySelectorAll('variant-radios, variant-selects');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', pauseAndResetAllVideos);
  });
  
  // Make function globally available
  window.pauseAndResetAllVideos = pauseAndResetAllVideos;
  
  // Also update existing pauseAllMedia if it exists
  if (typeof window.pauseAllMedia === 'function') {
    const originalPauseAllMedia = window.pauseAllMedia;
    window.pauseAllMedia = function() {
      originalPauseAllMedia();
      pauseAndResetAllVideos();
    };
  } else {
    window.pauseAllMedia = pauseAndResetAllVideos;
  }
  
});